module.exports = __webpack_public_path__ + "img/faq-info.187ec49c.png";